export default {
  delivery_order: {
    'found delivery order with status CONFIRMED': 'delivery.provider.orderStatusConfirmed',
    'status is not SENT': 'delivery.provider.statusIsNotSent',
    'found different warehouse_id': 'delivery.provider.foundDifferentWarehouse',
    'invalid destination geolocation': 'delivery.provider.invalidDestinationGeolocation',
    'invalid origin geolocation': 'delivery.provider.invalidOriginGeolocation',
    'Item type must be supply': 'delivery.provider.itemTypeMustBeSupply',
    'accurate address is empty': 'delivery.provider.accurateAddressIsEmpty',
    'all warehouses are empty': 'delivery.provider.allWarehousesAreEmpty',
    'origin address is invalid or not specific': 'delivery.provider.originIsInvalid',
    'destination address is invalid or not specific': 'delivery.provider.destinationIsInvalid',
    'origin address is empty': 'delivery.provider.originIsEmpty',
    'destination address is empty': 'delivery.provider.destinationIsEmpty',
    'not found': 'delivery.provider.deliveryOrderNotFound',
  },
  external_reference: {
    'failed to change status, only admin can change the order status': 'delivery.provider.failedChangeOrderStatus'
  }
}